import { useState } from 'react';
import { singletonHook } from 'react-singleton-hook';
import { Alert } from "../Utils/Alert";

const initAlert = Alert.createEmpty();
let globalSetAlert = () => {
  throw new Error( 'you must useDarkMode before setting its state' );
};

export const useAlert = singletonHook( initAlert, () => {
  const [ alert, setAlert ] = useState( initAlert );
  globalSetAlert = setAlert;
  return alert;
} );

export const setAlert = mode => globalSetAlert( mode );